const styles = (theme) => ({
  selectDate: {
    minHeight: '36px',
    maxWidth: '360px',
    fontSize: '12px',
    color: theme.TextColor,
    backgroundColor: theme.ModalBGColor,
    display: 'flex',
    flexDirection: 'column-reverse',
    boxShadow:
      '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',

    // Defined Ranges Wrapper
    '& .rdrDefinedRangesWrapper': {
      backgroundColor: theme.ModalBGColor,
      width: '100%',
      border: 'none',

      '& .rdrStaticRanges': {
        backgroundColor: theme.ModalBGColor,
        padding: '0 10px',
        display: 'flex',
        gap: '10px',
        flexDirection: 'row',
        justifyContent: 'space-around',
        flexWrap: 'wrap',
        border: 'none',
        marginTop: 24
      }
    },

    // Static Range Button Styling
    '& .rdrStaticRange': {
      border: `1px solid ${theme.ColumnHeaderTextColor}`,
      borderRadius: '20px',
      background: theme.ModalBGColor,
      color: theme.ColumnHeaderTextColor
    },

    '& .rdrStaticRange:hover .rdrStaticRangeLabel, & .rdrStaticRange:focus .rdrStaticRangeLabel': {
      background: theme.palette.primary.main,
      color: theme.satelliteViewRouteColor,
      borderRadius: '20px'
    },

    '& .rdrMonth': {
      padding: 0
    },

    // Date Display Styling
    '& .rdrDateDisplayWrapper': {
      backgroundColor: theme.AppBGColor,
      '& .rdrDateDisplayItem': {
        backgroundColor: theme.ModalBGColor,
        borderColor: theme.disabledColor,
        '& input': {
          color: theme.disabledColor
        }
      },
      '& .rdrDateDisplayItem.rdrDateDisplayItemActive': {
        borderColor: theme.palette.primary.main,
        '& input': {
          color: theme.ColumnHeaderTextColor
        }
      }
    },

    '& .rdrCalendarWrapper': {
      backgroundColor: theme.ModalBGColor
    },

    '& .rdrNextPrevButton': {
      background: 'none'
    },
    '& .rdrNextButton i': {
      borderColor: `transparent transparent transparent ${theme.ColumnHeaderTextColor}`
    },
    '& .rdrPprevButton i': {
      borderColor: `transparent ${theme.ColumnHeaderTextColor} transparent transparent`
    },

    // Month & Year Pickers
    '& .rdrMonthAndYearPickers select': {
      color: theme.ColumnHeaderTextColor,
      appearance: 'none',
      background: 'none',
      backgroundColor: theme.ModalBGColor,
      padding: 10
    },

    '& .rdrYearPicker::after, & .rdrMonthPicker::after': {
      content: "'\\25BC'",
      color: theme.ColumnHeaderTextColor
    },

    '& .rdrWeekDay': {
      color: theme.iconColor
    },

    '& .rdrDayNumber span': {
      color: theme.ColumnHeaderTextColor
    },

    '& .rdrDayDisabled': {
      background: 'none'
    },

    '& .rdrDayDisabled .rdrDayNumber span': {
      backgroundColor: 'transparent',
      color: theme.disabledColor
    },

    '& .rdrDayPassive .rdrDayNumber span': {
      color: theme.disabledColor
    }
  }
});

export default styles;
